var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "header",
        [
          _c("b-navbar", {
            attrs: { "fixed-top": "" },
            scopedSlots: _vm._u([
              {
                key: "brand",
                fn: function() {
                  return [
                    _c(
                      "b-navbar-item",
                      {
                        staticStyle: { "background-color": "transparent" },
                        attrs: { tag: "router-link", to: { path: "/" } }
                      },
                      [
                        _c("img", {
                          staticClass: "is-block",
                          attrs: {
                            src: "https://www.fmi.org/svg/fmi-logo.svg",
                            alt: "FMI Appointment Scheduler"
                          }
                        })
                      ]
                    )
                  ]
                },
                proxy: true
              },
              {
                key: "start",
                fn: function() {
                  return [
                    _vm.user.isAdmin
                      ? _c(
                          "b-navbar-dropdown",
                          { attrs: { label: "Select a Meeting" } },
                          _vm._l(_vm.filteredMeetings, function(meeting) {
                            return _c(
                              "b-navbar-item",
                              {
                                key: meeting.id,
                                attrs: {
                                  tag: "router-link",
                                  to: {
                                    name: "MeetingDashboard",
                                    params: { id: meeting.id }
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(meeting.name) +
                                    "\n            "
                                ),
                                meeting.is_archived
                                  ? _c(
                                      "span",
                                      { staticClass: "ml-1 font-bold" },
                                      [_vm._v("[archived]")]
                                    )
                                  : _vm._e()
                              ]
                            )
                          }),
                          1
                        )
                      : _vm._e()
                  ]
                },
                proxy: true
              },
              {
                key: "end",
                fn: function() {
                  return [
                    !_vm.user.isLoggedIn
                      ? _c("div", { staticClass: "navbar-item" }, [
                          _c("div", { staticClass: "buttons" }, [
                            _c(
                              "button",
                              {
                                staticClass: "button is-primary",
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.logIn($event)
                                  }
                                }
                              },
                              [_c("strong", [_vm._v("Log in")])]
                            )
                          ])
                        ])
                      : _c(
                          "b-navbar-dropdown",
                          { attrs: { label: _vm.user.fullName, right: "" } },
                          [
                            _c(
                              "b-navbar-item",
                              { staticClass: "field", attrs: { tag: "div" } },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "button is-fullwidth",
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.logout($event)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Log out\n            "
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("section", { staticClass: "page-body mt-3" }, [
        _c(
          "div",
          { staticClass: "container column" },
          [_c("router-view", { key: _vm.$route.fullPath })],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "footer",
        { staticClass: "footer is-hidden-print py-4 px-1 lg:py-12 lg:pb-16" },
        [
          _c(
            "div",
            { staticClass: "container column lg:flex justify-between" },
            [
              _c("div", { staticClass: "content block" }, [
                _c("p", [
                  _c("span", { staticClass: "mr-1" }, [_vm._v("©")]),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "copy-year",
                    domProps: { textContent: _vm._s(_vm.copyYear) }
                  }),
                  _vm._v(" "),
                  _c("strong", { staticClass: "is-semibold" }, [_vm._v("FMI")]),
                  _vm._v(". All rights reserved.\n        ")
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1)
              ]),
              _vm._v(" "),
              _vm._m(2)
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("portal-target", { attrs: { name: "modals" } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "icon mr-1" }, [
        _c("i", {
          staticClass: "fas fa-map-marker-alt",
          attrs: { title: "Address" }
        })
      ]),
      _vm._v(" "),
      _c("span", [_vm._v("251 18th Street S, Suite 1200, Arlington, VA 22202")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "icon mr-1" }, [
        _c("i", { staticClass: "fas fa-phone", attrs: { title: "Phone" } })
      ]),
      _c("span", { staticClass: "mr-4" }, [_vm._v("(202) 452-8444")]),
      _vm._v(" "),
      _c("span", { staticClass: "icon mr-1" }, [
        _c("i", { staticClass: "fas fa-fax", attrs: { title: "Fax" } })
      ]),
      _c("span", [_vm._v("(202) 429-4519")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("p", { staticClass: "has-text-right has-text-left-mobile" }, [
        _c("a", { attrs: { href: "#" } }, [_vm._v("Help")]),
        _vm._v(" ·\n          "),
        _c(
          "a",
          {
            attrs: { href: "https://www.fmi.org/utility-pages/privacy-policy" }
          },
          [_vm._v("Privacy Policy")]
        ),
        _vm._v("\n          ·\n          "),
        _c(
          "a",
          { attrs: { href: "https://www.fmi.org/utility-pages/terms-of-use" } },
          [_vm._v("Terms of Use")]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 